document.addEventListener('DOMContentLoaded', () => {
	const fileInput = document.querySelector('.file-input');
	const fileName = document.querySelector('.file-name');

	if (fileInput) {
		fileInput.addEventListener('change', () => {
			if (fileInput.files.length) {
				const file = fileInput.files[0];

				fileName.innerHTML = '';

				const fileDetails = document.createElement('span');
				fileDetails.textContent = file.name;
				fileDetails.className = 'is-pre-wrap is-fullheight is-block';

				const deleteIcon = document.createElement('i');
				deleteIcon.className =
					'fa-solid fa-times is-clickable ml-2 mt-1 has-text-primary';

				deleteIcon.addEventListener('click', () => {
					fileName.innerHTML = '';
					fileInput.value = '';
				});

				fileName.appendChild(fileDetails);
				fileName.appendChild(deleteIcon);
			}
		});
	}
});
